export default __webpack_public_path__ + "static/media/single_web-xs@2x.da7950c7.jpg";